export const HelpSupportActionTypes = {
    CREATE_SUPPORT_DATA_FIRST: '@@auth/CREATE_SUPPORT_DATA_FIRST',
    CREATE_SUPPORT_DATA_LOADING: '@@auth/CREATE_SUPPORT_DATA_LOADING',
    CREATE_SUPPORT_DATA_SUCCESS: '@@auth/CREATE_SUPPORT_DATA_SUCCESS',
    CREATE_SUPPORT_DATA_ERROR: '@@auth/CREATE_SUPPORT_DATA_ERROR',
    CREATE_SUPPORT_DATA_RESET: '@@auth/CREATE_SUPPORT_DATA_RESET',

    SUPPORT_DATA_FIRST: '@@auth/SUPPORT_DATA_FIRST',
    SUPPORT_DATA_LOADING: '@@auth/SUPPORT_DATA_LOADING',
    SUPPORT_DATA_SUCCESS: '@@auth/SUPPORT_DATA_SUCCESS',
    SUPPORT_DATA_ERROR: '@@auth/SUPPORT_DATA_ERROR',
    SUPPORT_DATA_RESET: '@@auth/SUPPORT_DATA_RESET',

    SUPPORT_ADMIN_DATA_FIRST: '@@auth/SUPPORT_ADMIN_DATA_FIRST',
    SUPPORT_ADMIN_DATA_LOADING: '@@auth/SUPPORT_ADMIN_DATA_LOADING',
    SUPPORT_ADMIN_DATA_SUCCESS: '@@auth/SUPPORT_ADMIN_DATA_SUCCESS',
    SUPPORT_ADMIN_DATA_ERROR: '@@auth/SUPPORT_ADMIN_DATA_ERROR',
    SUPPORT_ADMIN_DATA_RESET: '@@auth/SUPPORT_ADMIN_DATA_RESET',

    UPDATE_SUPPORT_DATA_FIRST: '@@auth/UPDATE_SUPPORT_DATA_FIRST',
    UPDATE_SUPPORT_DATA_LOADING: '@@auth/UPDATE_SUPPORT_DATA_LOADING',
    UPDATE_SUPPORT_DATA_SUCCESS: '@@auth/UPDATE_SUPPORT_DATA_SUCCESS',
    UPDATE_SUPPORT_DATA_ERROR: '@@auth/UPDATE_SUPPORT_DATA_ERROR',
    UPDATE_SUPPORT_DATA_RESET: '@@auth/UPDATE_SUPPORT_DATA_RESET',

    CREATE_CHAT_DATA_FIRST: '@@auth/CREATE_CHAT_DATA_FIRST',
    CREATE_CHAT_DATA_LOADING: '@@auth/CREATE_CHAT_DATA_LOADING',
    CREATE_CHAT_DATA_SUCCESS: '@@auth/CREATE_CHAT_DATA_SUCCESS',
    CREATE_CHAT_DATA_ERROR: '@@auth/CREATE_CHAT_DATA_ERROR',
    CREATE_CHAT_DATA_RESET: '@@auth/CREATE_CHAT_DATA_RESET',

    GET_CHAT_DATA_FIRST: '@@auth/GET_CHAT_DATA_FIRST',
    GET_CHAT_DATA_LOADING: '@@auth/GET_CHAT_DATA_LOADING',
    GET_CHAT_DATA_SUCCESS: '@@auth/GET_CHAT_DATA_SUCCESS',
    GET_CHAT_DATA_ERROR: '@@auth/GET_CHAT_DATA_ERROR',
    GET_CHAT_DATA_RESET: '@@auth/GET_CHAT_DATA_RESET',

    GET_TICKET_BY_ID_FIRST: '@@auth/GET_TICKET_BY_ID_FIRST',
    GET_TICKET_BY_ID_LOADING: '@@auth/GET_TICKET_BY_ID_LOADING',
    GET_TICKET_BY_ID_SUCCESS: '@@auth/GET_TICKET_BY_ID_SUCCESS',
    GET_TICKET_BY_ID_ERROR: '@@auth/GET_TICKET_BY_ID_ERROR',
    GET_TICKET_BY_ID_RESET: '@@auth/GET_TICKET_BY_ID_RESET',
};
